import { Box, Row, Space } from "@stenajs-webui/core";
import type { FC } from "react";

import {
  BookingColumn,
  BookingColumnGrid,
} from "../../../common-ui/layout/BookingColumnGrid";
import type { AllIntermodalVehicleTypesQueryRefProps } from "../../../services/intermodal/hooks/useAllIntermodalVehicleTypesAsOptions";
import type { GoodsTypesQueryRefProps } from "../../../services/intermodal/hooks/useGoodsTypes";
import { BookingSection } from "../../manage/details/components/sections/BookingSection";
import { CreateIntermodalInformationBanners } from "../common/banners/CreateIntermodalInformationBanners";
import { IntermodalDetailsCard } from "../common/IntermodalDetailsCard";
import { CreateIntermodalCargoSection } from "./sections/CreateIntermodalCargoSection";
import { CreateIntermodalConnectionsSection } from "./sections/CreateIntermodalConnectionsSection";
import { CreateIntermodalDepartureSection } from "./sections/CreateIntermodalDepartureSection";
import { CreateIntermodalDetailsSection } from "./sections/CreateIntermodalDetailsSection";
import { CreateIntermodalVehicleSection } from "./sections/CreateIntermodalVehicleSection";

interface Props
  extends GoodsTypesQueryRefProps, AllIntermodalVehicleTypesQueryRefProps {}

export const IntermodalBookingCreate: FC<Props> = ({
  goodsTypesQueryRef,
  vehicleTypesQueryRef,
}) => (
  <>
    <Row display={["flex", null, null, null, "none"]} spacing={3}>
      <CreateIntermodalConnectionsSection compact />
    </Row>
    <CreateIntermodalInformationBanners />
    <Row flexDirection={["column", null, null, null, "row"]}>
      <Box width={340} display={["none", null, null, null, "flex"]}>
        <CreateIntermodalConnectionsSection />
      </Box>
      <Space num={2} />
      <IntermodalDetailsCard>
        <BookingColumnGrid>
          <BookingColumn>
            <BookingSection title={"Departure"}>
              <CreateIntermodalDepartureSection />
            </BookingSection>
          </BookingColumn>
          <BookingColumn>
            <BookingSection title={"Vehicle"}>
              <CreateIntermodalVehicleSection
                vehicleTypesQueryRef={vehicleTypesQueryRef}
              />
            </BookingSection>
          </BookingColumn>
          <BookingColumn>
            <BookingSection title={"Cargo"}>
              <CreateIntermodalCargoSection
                goodsTypesQueryRef={goodsTypesQueryRef}
              />
            </BookingSection>
          </BookingColumn>
          <BookingColumn>
            <BookingSection title={"Details"}>
              <CreateIntermodalDetailsSection />
            </BookingSection>
          </BookingColumn>
        </BookingColumnGrid>
      </IntermodalDetailsCard>
    </Row>
  </>
);
